"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[59715],{

/***/ 59715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var DetailIncludedPriceIcon = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "10px",
        height: "11px",
        viewBox: "0 0 10.0 11.0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "i0x",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "i1x",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M4.31927628,0 C4.34597969,0.0200275562 4.37490838,0.0400551123 4.40161179,0.0623079525 C5.81021657,1.15047184 7.21659607,2.23641044 8.62075028,3.32457432 L8.62075028,9.18819771 C7.3234097,9.70891417 5.90590378,9.99375052 4.42163934,9.99375052 C2.85281411,9.99375052 1.35742325,9.67330962 0,9.09473578 L0,3.33570074 C1.4063795,2.24976214 2.812759,1.16382354 4.2191385,0.0778849406 C4.25029247,0.0534068164 4.28589702,0.0267034082 4.31927628,0 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-1284.0 -1410.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    clipPath: "url(#i0x)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        transform: "translate(1284.0 1410.0)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(0.5350288453228131 0.1762341304522579)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#i1x)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 8.62075028,0 8.62075028,9.99375052 0,9.99375052 0,0",
                                    stroke: "none",
                                    fill: "#ED7722"
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DetailIncludedPriceIcon);


/***/ })

}]);